const stats = [
  { value: '5000万+', label: '全球累计用户', icon: 'ri-user-3-line' },
  { value: '40%', label: '页面加载速度提升', icon: 'ri-speed-up-line' },
  { value: '99.9%', label: '恶意网站拦截率', icon: 'ri-shield-check-line' },
  { value: '200+', label: '覆盖国家和地区', icon: 'ri-global-line' },
];

export default function StatsSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-6">
              <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-accent-100 flex items-center justify-center">
                <i className={`${stat.icon} text-accent-600 text-xl w-5 h-5 flex items-center justify-center`}></i>
              </div>
              <div className="text-3xl font-heading font-bold text-foreground-950 mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}